export default __webpack_public_path__ + "static/media/cz.5a24757d.svg";